import { isNotFoundRoute } from '../../appRoutes'
import ErrorScreen from './ErrorScreen'
import { buildErrorScreen } from './ErrorScreenProvider'

export default () => {
  if (!isNotFoundRoute) return null
  return <ErrorScreen {...buildErrorScreen('not-found')} />
}
